/**
 * @module app.shared
 */

import { autoinject, bindingMode, TaskQueue } from "aurelia-framework";
import { bindable } from 'aurelia-typed-observable-plugin';
import { IToggle } from 'app/shared/elements/forms/input-base';
import { selectText } from 'app/shared/lib/dom';

@autoinject()
export class EssRadioCustomElement implements IToggle {

    ////****************** Fields and Properties ************************************////
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    checked: any = null;

    @bindable()
    model: any;

    @bindable()
    value: string | null = null;

    @bindable()
    public autocomplete: string = 'off';

    @bindable()
    readonly: boolean = false;

    @bindable()
    disabled: boolean = false;

    @bindable.string()
    public testName: string = '';

    selectText = selectText;

    @bindable.string()
    public groupName: string = '';

    @bindable() protected labelledbyId: string | null = null;  //An element's `id`. Sets the button's `aria-labelledby`
    @bindable() protected arialabelValue: string | null = null;

    // refs
    protected $input!: HTMLInputElement;

    constructor(protected readonly taskQueue: TaskQueue) { }

    protected handleInputFocus(event: FocusEvent) {
        //Adds materialize class to show focus. Materialize does not apply do this innately when we use .focus() on the input
        this.taskQueue.queueTask(() => this.$input.classList.add('tabbed'));
    }
}
